import React from "react";
import { Route, Routes } from "react-router-dom";
import { AttendanceCalender } from ".";
import "./style/attendance.style.css";

export const Attendance = () => {
  return (
    <Routes>
      <Route element={<AttendanceCalender />} path={"/"} />
    </Routes>
  );
};
